import { useAuth } from 'context/auth';
import { useRingover } from 'context/ringover';
import CallIntegrationType from 'crono-fe-common/types/enums/callIntegrationType';
import ringoverLogo from 'assets/images/integrations_ringover.svg';
import { CallFloatingUIBase } from 'components/CallFloatingUIBase';

export const RINGOVER_CALL_UI_CONTAINER_ID = 'crono-ringover-call-ui-container';

export const RingoverCallFloatingUI = () => {
  const { closeFloatingUI, isFloatingUIVisible, isCallActive } = useRingover();
  const { user } = useAuth();

  if (!user || user.callIntegrationType !== CallIntegrationType.Ringover) {
    return null;
  }

  return (
    <CallFloatingUIBase
      logo={ringoverLogo}
      logoAlt="ringover logo"
      title="Ringover"
      containerId={RINGOVER_CALL_UI_CONTAINER_ID}
      isFloatingUIVisible={isFloatingUIVisible}
      isCallActive={isCallActive}
      closeFloatingUI={closeFloatingUI}
    />
  );
};
